// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"036d4fb5","132":"26760ad9","160":"26916e43","170":"8ccd59a8","225":"bec9e9e1","453":"ac530851","652":"32cde392","818":"8a835087","954":"8b02a6d0","966":"e100b459","969":"a947861e"}[chunkId] + ".chunk.js";
};